import { workLogProxy, workLogProxyBody } from './index';
// proxy/workLog/1.0/
// proxyBody/workLog/1.0/

// 업무일지 기준조회
function getWorkLogStd() {
  return workLogProxy.get('mgr/detail');
}

// 업무일지 기준조회
function getWorkLogMainStdInfo() {
  return workLogProxy.get('main/std-info');
}

// 업무일지 기본정보 조회
function getWorkLogInfo(params) {
  return workLogProxy.get('main/info', { params });
}

// 업무일지 조회
function getWorkLogDetail(params) {
  return workLogProxy.get('main/detail', { params });
}

// 업무일지 등록
function postWorkLog(params) {
  return workLogProxyBody.post('main/save', params);
}

// 업무일지 삭제
function deleteWorkLog(params) {
  return workLogProxyBody.post('main/delete', params);
}

// 미작성건 정보조회
function getMissingInfo() {
  return workLogProxy.get('sta/not-registered/info', {});
}

// 미열람건 정보조회
function getNotViewedInfo() {
  return workLogProxy.get('sta/not-viewed/info');
}

// 조회권한 부서목록조회
function getViewAuthOrgList(params) {
  return workLogProxy.get('main/team/org/list', { params });
}

// 업무일지 팀별 작성목록조회
function getWorkLogListByTeam(params) {
  return workLogProxy.get('main/team/list', { params });
}

// 대상자 근태현황 목록조회
function getTargetGntStatus(params) {
  return workLogProxy.get('main/team/target-gnt/list', { params });
}

// 업무일지 열람처리
function postWorkLogAccess(params) {
  return workLogProxyBody.post('main/team/access/save', params);
}

// 업무일지 피드백저장
function postWorkLogfeedback(params) {
  return workLogProxyBody.post('main/team/feedback/save', params);
}

export {
  getWorkLogStd,
  getWorkLogMainStdInfo,
  getWorkLogInfo,
  getWorkLogDetail,
  postWorkLog,
  deleteWorkLog,
  getMissingInfo,
  getNotViewedInfo,
  getViewAuthOrgList,
  getWorkLogListByTeam,
  getTargetGntStatus,
  postWorkLogAccess,
  postWorkLogfeedback,
};
